import { useMutation } from "@apollo/client";
import { CREATE_SPONSOR } from "../graphql";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Button, Container, TextField } from "@mui/material";
import { toast } from "react-toastify";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { PageContainer } from "../../../components/PageContainer";
import { ButtonContainer } from "../../../components/ButtonContainer";

const schema = yup
  .object({
    name: yup.string().required(),
  })
  .required();

export const SponsorForm = () => {
  const navigate = useNavigate();
  const [createSponsor, { loading: updateLoading, error }] = useMutation(
    CREATE_SPONSOR,
    {
      onCompleted: (data) => {
        toast("sponsor created");
        navigate(`/sponsor/${data.createSponsor.id}`);
      },
    }
  );

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = (val: any) => {
    const { name } = val;
    createSponsor({
      variables: {
        name,
        value: {},
      },
    });
  };

  return (
    <PageContainer title="Create Sponsor">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Container style={{ flexDirection: "column", display: "flex" }}>
          <TextField
            id="outlined-basic"
            label="Name"
            variant="outlined"
            {...register("name")}
          />
          <p>{errors.name?.message}</p>
          <ButtonContainer>
            <Button type="submit" variant="contained">
              Save
            </Button>
          </ButtonContainer>
        </Container>
      </form>
    </PageContainer>
  );
};
